import { render, staticRenderFns } from "./rto_mr.vue?vue&type=template&id=68f121be&"
import script from "./rto_mr.vue?vue&type=script&lang=js&"
export * from "./rto_mr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports